import React from "react";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";

import CONSTANT from "./../../constant";
import UserList from "./../../component/user/aparList";
import Loader from "./../../component/common/Loader";
import { getAparUserList } from "./../../actions/AppraisalCycleAction";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';

class ManageEmployee extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      page: 1,
      limit: 50,
      list: undefined,
      count: 0,
      showLoader: false,
      search: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Manage Employee - " + CONSTANT.organisation.name;
    this.loadList();
  }

  render() {
    const { page, limit, list, count, showLoader, search } = this.state;
    return (
      <div className="container-fluid mb-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card homedob">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="page-title">Manage Employee</h1>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  {/* <Link
                    to={CONSTANT.component.adminAddUser.url}
                    className="btn btn-sm submit-button d-inline-block mr-3"
                  >
                    <i className="fa fa-plus-circle mr-2" />
                    Add Employee
                  </Link>
                  <Link
                    to={CONSTANT.component.adminUploadUserExcel.url}
                    className="btn btn-sm submit-button d-inline-block mr-3"
                  >
                    <i className="fa fa-plus-circle mr-2" />
                    Upload Excel
                  </Link> */}
                  <button
                    onClick={this.downloadExcel}
                    className="btn btn-sm submit-button d-inline-block"
                  >
                    <i className="fa fa-download mr-2" />
                    Download Excel
                  </button>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <div className="input-group" style={{ maxWidth: "320px" }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search employee..."
                      value={search}
                      onChange={this.handleSearch}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">
                        <i className="fa fa-search" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <div className="list-container">
                    <div className="table-container">
                      <div className="table-wrapper radius-4">
                        <UserList list={list} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {count > limit && (
                <div className="mt-4 px-3">
                  <ResponsivePagination
                    activeItemClassName="Pagi-number-ac"
                    current={page}
                    total={Math.ceil(count / limit)}
                    onPageChange={this.changePage}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {showLoader && <Loader />}
      </div>
    );
  }

  handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const search = e.target.value;
    this.setState({ search, page: 1 }, () => {
      this.loadList();
    });
  };

  loadList = () => {
    const { page, limit, search } = this.state;
    getAparUserList(page, limit, search).then((res: any) => {
      this.setState({ list: res.result.list, count: res.result.count });
    });
  };

  openDetailPage = (url: string) => {
    this.props.history.push(url);
  };

  changePage = (newPage: number) => {
    this.setState({ page: newPage }, () => {
      this.loadList();
    });
  };

  downloadExcel = (e: any) => {
    this.setState({ showLoader: true });
    const { count } = this.state;
    getAparUserList(1, count).then((res: any) => {
      this.setState({ showLoader: false });
      let date = new Date();
      let filename = `employee-report-${date.getTime()}.xlsx`;

      let dataToExport: any = [];
      var ws_name = "Sheet1";
      res.result.list.map(function (item: any) {
        delete item.code;
        delete item.modifiedOn;
        delete item.userTypeName;
        delete item.loginStatusName;

        dataToExport.push({
          ...item,
        });
      });
      var wb = XLSX.utils.book_new(),
        ws = XLSX.utils.json_to_sheet(dataToExport);
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(wb, filename);
    });
  };
}

export default ManageEmployee;